module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAAx0lEQVQ4jdXTsU4CQRQF0DPrJmglJDaW2/kB9Co9NV9B4af4M3yOxh9QGjRoMRS7kNmFCW4gJt5q3n03d27y3gvxRQ53eMAEj3jDeE9VxVZZdtpTzBqT207vBgHXCbfGVyoKScIBVrjIZmaEj6SOeFbFpy1RJM2rI2aHEDBPiSIjzGHZmAR1Wt0QfQ2P4s8NF7g/p2FQT//XSNdmqL0SuQ/29VXc8f9/KL1Rqi9koH2j/fAahs1rXeIdlycG2w7zs8D3iWYpfjZcUh2DAjR6kAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthIcon/room.png
// module id = Rkh5
// module chunks = 4